/*
 * @Descripttion: 
 * @Author: Lius
 * @version: 
 * @Date: 2022-05-29 09:59:15
 * @LastEditors: Lius
 * @LastEditTime: 2022-06-07 17:26:43
 */
import Vue from 'vue'
import App from './App'
import Axios from 'axios'  //导入axios
import qs from 'qs'
//预览图片
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer)

//将axios挂载到原型上
Vue.prototype.$axios = Axios;
Vue.prototype.qs = qs;
//富文本
import VueQuillEditor  from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'bootstrap'//.将bootstrap全局引入
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
//打印
import Print from 'vue-print-nb'
Vue.use(Print);//注册

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css
Vue.use(VueQuillEditor);

import '@/icons' // icon
import '@/permission' // permission control

import { parseTime } from './utils/index'
Vue.prototype.parseTime = parseTime


import router from './router'
import store from './store'

Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js